export const DYNAMIC_EVMS_CONFIG = [
    {
        assetName: 'ethereumsepolia',
        combinedAssetName: '_ethereumtestnet',
        isTestnet: true,
        chainInfo: {
            chainId: '0xaa36a7',
            blockExplorerUrls: ['https://sepolia.etherscan.io'],
            chainName: 'Ethereum Sepolia',
            nativeCurrency: {
                symbol: 'ETH',
                name: 'Ethereum Sepolia',
                decimals: 18,
            },
            rpcUrls: ['https://eth-sepolia-qn.a.exodus.io/rpc'],
        },
        feeData: { tipGasPrice: '1 wei' },
    },
    {
        assetName: 'immutable',
        chainInfo: {
            chainId: '0x343b',
            blockExplorerUrls: ['https://explorer.immutable.com'],
            chainName: 'Immutable zkEVM',
            nativeCurrency: {
                symbol: 'IMX',
                name: 'Immutable Coin',
                decimals: 18,
            },
            rpcUrls: ['https://immutable-rpc.a.exodus.io'],
        },
    },
    {
        assetName: 'rari',
        combinedAssetName: '_ethereum',
        chainInfo: {
            chainId: '0x52415249',
            blockExplorerUrls: ['https://mainnet.explorer.rarichain.org'],
            chainName: 'RARI Chain',
            nativeCurrency: {
                symbol: 'ETH',
                name: 'Ethereum',
                decimals: 18,
            },
            rpcUrls: ['https://rari.a.exodus.io'],
        },
    },
    {
        assetName: 'zksync',
        combinedAssetName: '_ethereum',
        chainInfo: {
            chainId: '0x144',
            blockExplorerUrls: ['https://era.zksync.network'],
            chainName: 'zkSync Era',
            nativeCurrency: {
                symbol: 'ETH',
                name: 'Ethereum',
                decimals: 18,
            },
            rpcUrls: ['https://zksync.a.exodus.io'],
        },
    },
    {
        assetName: 'astar',
        combinedAssetName: '_ethereum',
        chainInfo: {
            chainId: '0xec0',
            blockExplorerUrls: ['https://astar-zkevm.explorer.startale.com'],
            chainName: 'Astar zkEVM',
            nativeCurrency: {
                symbol: 'ETH',
                name: 'Ethereum',
                decimals: 18,
            },
            rpcUrls: ['https://astar.a.exodus.io'],
        },
    },
    {
        assetName: 'kroma',
        combinedAssetName: '_ethereum',
        chainInfo: {
            chainId: '0xff',
            blockExplorerUrls: ['https://blockscout.kroma.network'],
            chainName: 'Kroma',
            nativeCurrency: {
                symbol: 'ETH',
                name: 'Ethereum',
                decimals: 18,
            },
            rpcUrls: ['https://kroma-api.a.exodus.io'],
        },
    },
    {
        assetName: 'celo',
        chainInfo: {
            chainId: '0xa4ec',
            blockExplorerUrls: ['https://explorer.celo.org/mainnet'],
            chainName: 'Celo',
            nativeCurrency: {
                symbol: 'CELO',
                name: 'Celo',
                decimals: 18,
            },
            rpcUrls: ['https://celo.a.exodus.io'],
        },
    },
    {
        assetName: 'moonbeam',
        chainInfo: {
            chainId: '0x504',
            blockExplorerUrls: ['https://moonscan.io'],
            chainName: 'Moonbeam',
            nativeCurrency: {
                symbol: 'GLMR',
                name: 'Moonbeam',
                decimals: 18,
            },
            rpcUrls: ['https://moonbeam.a.exodus.io'],
        },
    },
];
